import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CartService } from 'src/app/shared/services/cart.service';
import { ServizioMenuService } from 'src/app/shared/services/servizio-menu.service';
import { StoreService } from 'src/app/shared/services/store.service';

@Component({
  selector: 'app-restaurant-header',
  templateUrl: './restaurant-header.component.html',
  styleUrls: ['./restaurant-header.component.scss']
})
export class RestaurantHeaderComponent implements OnInit {
  logo: string | null = null;
  nome: string | null = null;
  headerColor: string | null = null;
  accentOppositeColor: string | null = null;
  currentLang: string = 'it'; 

  cartCount$: Observable<number>;
  searchVisible: boolean = false;
  searchQuery: string = '';
  
  constructor(private route: ActivatedRoute, 
              private menuService: ServizioMenuService,
              private storeService: StoreService,
              private translate: TranslateService,
              public cartService: CartService)
              { this.cartCount$ = this.cartService.quantity$; }

 
              ngOnInit(): void {
                this.storeService.load().then(() => {
                  this.logo = this.storeService.logo;
                  this.nome = this.storeService.name;
                 });

                  const savedLang = localStorage.getItem('lang') || 'it';
                  this.currentLang = savedLang;
                  this.translate.use(savedLang);
              }
            
              changeLang(lang: string): void {
                  this.currentLang = lang;
                  this.translate.use(lang);
                  localStorage.setItem('lang', lang);
                }


              toggleSearch(): void {
                this.searchVisible = !this.searchVisible;
              }
            
}